import { render, staticRenderFns } from "./PDFexport.vue?vue&type=template&id=0c60a0ee"
import script from "./PDFexport.vue?vue&type=script&lang=js"
export * from "./PDFexport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports